module.exports = __webpack_public_path__ + "media/images/front/icon_up_d-59da3ae2c474674baaf34f0110cb41d4.png";